module.exports = __webpack_public_path__ + "img/red_032.3f709803.png";